import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SuccessResponse, PolicyCancelResponse } from 'src/app/common/models';
import { environment as env } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class PolicyService {
  private BASE_URL = `${env.PROPERTYBR_API_BASE_URL}/artico/policy`;

  private BASE_URL_AR = `${env.ARTICO_API_BR_BASE_URL}/api/v1`;

  constructor(private httpClient: HttpClient) {}

  save(data: any) {
    const URL = this.BASE_URL;
    return this.httpClient.post<SuccessResponse>(URL, data);
  }

  getPolicyList(typeFilter: string, dataCode: string, offset: string = '0', limit: string = '10') {
    const apiUrl = `${this.BASE_URL_AR}/web/property/br/proposals/list?codEmpresa=BR&offset=${offset}&limit=${limit}&sort=${typeFilter}&filter=${dataCode}`;
    return this.httpClient.get<SuccessResponse>(apiUrl);
  }

  downloadPolicy(numberPolicy: string) {
    const apiUrl = `${this.BASE_URL_AR}/web/policies/export/pdf/${numberPolicy}?codEmpresa=BR`;
    return this.httpClient.get<SuccessResponse>(apiUrl);
  }

  downloadInvoiceQuote(numberPolicy: string, numberQuote: string) {
    const apiUrl = `${this.BASE_URL_AR}/web/policies/invoice-quote/export/pdf/${numberPolicy}/0/quota/${numberQuote}?codEmpresa=BR`;
    return this.httpClient.get<SuccessResponse>(apiUrl);
  }

  downloadInvoice(number: string) {
    const apiUrl = `${this.BASE_URL_AR}/web/policies/invoice/export/pdf/${number}/0?codEmpresa=BR`;
    return this.httpClient.get<SuccessResponse>(apiUrl);
  }

  getPolicyID(id: string) {
    const apiUrl = `${this.BASE_URL_AR}/web/property/br/findPolicy/${id}?codEmpresa=BR`;
    return this.httpClient.get<SuccessResponse>(apiUrl);
  }

  getPolicyNumber(policyNumber: string, endorsementNumber: string) {
    const apiUrl = `${this.BASE_URL_AR}/web/property/br/findPolicyByMovement/${policyNumber}/${endorsementNumber}?codEmpresa=BR`;
    return this.httpClient.get<SuccessResponse>(apiUrl);
  }

  getEndoConfirm(policyNumber: string, endorsementNumber: string, obj: any) {
    const apiUrl = `${this.BASE_URL_AR}/web/property/br/endorsement/export/confirm/pdf/${policyNumber}/${endorsementNumber}?codEmpresa=BR`;
    return this.httpClient.get<SuccessResponse>(apiUrl, obj);
  }

  confirmEndorsement(proposalNumber: any) {
    const apiUrl = `${this.BASE_URL_AR}/web/property/br/endorsement/confirm?codEmpresa=BR`;
    return this.httpClient.post<SuccessResponse>(apiUrl, {
      proposalNumber,
    });
  }

  getEndoProposal(proposalNumber: string, endorsementNumber: string) {
    const apiUrl = `${this.BASE_URL_AR}/web/property/br/endorsement/export/proposal/pdf/${proposalNumber}/${endorsementNumber}?codEmpresa=BR`;
    return this.httpClient.get<SuccessResponse>(apiUrl);
  }

  precalculateCancellation(policyNumber: string, cancellationDate: string) {
    const apiUrl = `${this.BASE_URL_AR}/web/property/br/endorsement/precalculate-cancellation/${policyNumber}/${cancellationDate}?codEmpresa=BR`;
    return this.httpClient.get<PolicyCancelResponse>(apiUrl);
  }

  cancelPolicy(data: any) {
    const apiUrl = `${this.BASE_URL_AR}/web/property/br/endorsement/proposal?codEmpresa=BR`;
    return this.httpClient.post<SuccessResponse>(apiUrl, data);
  }

  saveEndorsement(data: any) {
    const apiUrl = `${this.BASE_URL}/endorsement`;
    return this.httpClient.post<SuccessResponse>(apiUrl, data);
  }

  queryEndorsementStatus(proposalNumber: string) {
    const apiUrl = `${this.BASE_URL_AR}/web/property/br/endorsement/status/${proposalNumber}?codEmpresa=BR`;
    return this.httpClient.get<any>(apiUrl);
  }

  generateFilesURL(data: any) {
    const apiUrl = `${this.BASE_URL_AR}/web/property/br/document/presignurl?codEmpresa=BR`;
    return this.httpClient.post<SuccessResponse>(apiUrl, data);
  }

  sendSinister(data: any) {
    const apiUrl = `${this.BASE_URL_AR}/web/property/br/sinister/register?codEmpresa=BR`;
    return this.httpClient.post<any>(apiUrl, data);
  }

  async doUploadSignedUrl(signedUrl: string, file: File) {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open('PUT', signedUrl, true);
      xhr.onload = function onLoad() {
        if (xhr.status >= 200 && xhr.status < 300) {
          resolve(xhr.response);
        } else {
          reject(new Error(xhr.statusText));
        }
      };
      xhr.onerror = function onError() {
        reject(new Error(xhr.statusText));
      };
      xhr.send(file);
    });
  }

  refreshStatusPayments(policyNumber: string) {
    const apiUrl = `${this.BASE_URL_AR}/policies/updateboleto/${policyNumber}?codEmpresa=BR`;
    return this.httpClient.put<any>(apiUrl, '');
  }
}
